'use strict';

module.exports = function () {
  var selector = '.js-back-button';
  $('body').on('click', selector, function (e) {
      e.preventDefault();
      window.history.back();
  });
};